/**
 * Picks v2 or v1 of the Cards-in-a-Deck page based on the redesign
 * flag. Same pattern as the other page switches.
 */
import React from 'react';
import { useRedesignFlag } from '../../../../utils/redesignFlag';
import CardsList   from './CardsList';
import CardsListV2 from '../v2/CardsListV2';

export default function CardsListSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? CardsListV2 : CardsList;
  return <Component {...props} />;
}
